// HERE WE STORE THE TOKEN OF USER WHICH WE USE TO PASS THROUGH PROTECTED API'S IN ITS HEADER

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    userZip: null
}

const userZipGameTokenSlice = createSlice({
    name: "userZipGameTokenSlice",
    initialState,
    reducers: {
        setUserZip: (state, action) => {
            state.userZip = action.payload;
            return state;
        },
        removeUserZip: (state, action) => {
            state.userZip = null;
            return state;
        }
    }

});

export const { setUserZip, removeUserZip } = userZipGameTokenSlice.actions;


export default userZipGameTokenSlice.reducer;